"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onReceiveMetaMessage = void 0;
const constants_1 = require("../constants");
function onReceiveMetaMessage(options) {
    var _a, _b;
    const { receivedMetaMessage } = options || {};
    if (receivedMetaMessage.messageType !== constants_1.MessageType.META ||
        typeof receivedMetaMessage.messageObj !== 'object' ||
        !((_b = (_a = receivedMetaMessage === null || receivedMetaMessage === void 0 ? void 0 : receivedMetaMessage.messageObj) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.arbitrary)) {
        return;
    }
    const receivedLiveSpaceData = receivedMetaMessage.messageObj.info.arbitrary;
    this.setSpaceSpecificData(() => (Object.assign(Object.assign({}, this.spaceSpecificData), { liveSpaceData: receivedLiveSpaceData })));
}
exports.onReceiveMetaMessage = onReceiveMetaMessage;
//# sourceMappingURL=onReceiveMetaMessage.js.map